import SidebarContent from "./SidebarContent";

const Sidebar = ({
  isOpen,
  items,
  isActiveRoute,
  onItemClick,
  className = "",
}) => {
  return (
    <div
      className={`fixed inset-0 z-40 transition-all duration-300 overflow-hidden ${
        isOpen ? "visible opacity-100" : "invisible opacity-0"
      }`}
    >
      {/* Sidebar Content */}
      <div
        className={`absolute top-0 right-0 h-full w-full bg-white shadow-2xl transform transition-transform duration-300 overflow-hidden ${
          isOpen ? "translate-x-0" : "translate-x-full"
        } ${className}`}
      >
        <SidebarContent
          items={items}
          isActiveRoute={isActiveRoute}
          onItemClick={onItemClick}
        />
      </div>
    </div>
  );
};

export default Sidebar;
